import { useAuthStore } from '@/Utility/auth/Auth';
import { useAppStore } from '@/inertia/AppStore';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/dash')({
  beforeLoad: ({
    location
  }) => {
    const userExists = useAuthStore.getState().user.userExists;
    if (userExists === false) {
      throw redirect({
        to: '/auth/login'
      });
    }
    if (location.pathname === '/dash') {
      throw redirect({
        to: '/dash/catalog'
      });
    }
  },
  onEnter() {
    useAppStore.setState({
      isDashboard: true
    });
  },
  onLeave() {
    useAppStore.setState({
      isDashboard: false
    });
  }
});